






















export default
    data: ->
        tabs:
            'filter_general':
                icon: ['fas', 'sliders']
                text: 'General'
            'filter_genre':
                icon: ['fas', 'film']
                text: 'Genre'
            'filter_language':
                icon: ['fas', 'language']
                text: 'Language'
            'filter_country':
                icon: ['fas', 'flag']
                text: 'Country'

    computed:
        current_tab: ->
            # needed because default child route does not render when the parent is a named route - which we are
            if @$route.matched.length == 1
                @$router.push({name: 'filter_general'})
            return @$route.matched[1].name

